import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppIncidentStakeholderService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppIncidentStakeholders`);
    }
}
